import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FooterGridComponent } from './footer-grid.component'
import { SharedModule } from '../shared/shared.module'
import { RouterModule } from '@angular/router'
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap'
import { ImageLinkComponent } from './image-link/image-link.component'
import { CollapseItemComponent } from './collapse-item/collapse-item.component'
import { PipesModule } from '../../pipes/pipes.module'



@NgModule({
  declarations: [FooterGridComponent, ImageLinkComponent, CollapseItemComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NgbCollapseModule,
    PipesModule
  ],
  exports: [FooterGridComponent]
})
export class FooterGridModule { }
